namespace Solovis.Portal {

    export interface ICachedModuleOptions {
        isEnabled(moduleName: string);
    }

    export class CachedModuleOptionsClient implements ICachedModuleOptions {

        private _portalServices: Solovis.Portal.IPortalServices;

        constructor(portalServices?: Solovis.Portal.IPortalServices) {
            this._portalServices = portalServices;
        }

        public isEnabled(moduleName: string) {
            if (!this._portalServices) {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // These permissions are loaded via ClientScript client-cached script. Permissions
            // are enforced server-side, but we can use the list of cached permissions to present
            // the user a list of things that they could do within the user interface.
            let solovisCustom = this._portalServices.customEnvironmentUserData();
            if (solovisCustom && solovisCustom.Modules && solovisCustom.Modules.entries) {
                let modData = solovisCustom.Modules.entries[moduleName]
                if (modData) {
                    return !!modData.isEnabled;
                }
            }

            return false;
        }
 
    }


    export const CachedModuleOptions = new CachedModuleOptionsClient();

}